import { createContext, useContext, useState } from "react";

export interface IClipboardContextProvider {
  clipboard: fabric.Object[];
  setClipboard: React.Dispatch<React.SetStateAction<fabric.Object[]>>;
}

const ClipboardContext = createContext<IClipboardContextProvider>({
  clipboard: [],
  setClipboard: () => {},
});

export const useClipboardContext = () => useContext<IClipboardContextProvider>(ClipboardContext);

const ClipboardContextProvider: React.FunctionComponent = (props) => {
  const [clipboard, setClipboard] = useState<Array<fabric.Object>>([]);

  return (
    <ClipboardContext.Provider value={{ clipboard, setClipboard }}>
      {/* @ts-ignore */}
      {props.children}
    </ClipboardContext.Provider>
  );
};

export default ClipboardContextProvider;
